import {
  GET_ADDRESS_BY_ID_REQUEST,
  GET_ADDRESS_BY_ID_SUCCESS,
  GET_ADDRESS_BY_ID_FAILURE,
} from '../../constants/ActionTypes'
import { AddressBookApi } from '../api/AddressBookApi';

// このactionはタイムラインや、レター送付などのcontainerで使われている
const getAddressByIdRequest = (contact, id) => ({
  type: GET_ADDRESS_BY_ID_REQUEST,
  payload: {
    contact: contact,
    id: id,
  }
});

const getAddressByIdSuccess = (contact) => ({
  type: GET_ADDRESS_BY_ID_SUCCESS,
  payload: {
    contact: contact,
  }
});

const getAddressByIdFailure = (error) => ({
  type: GET_ADDRESS_BY_ID_FAILURE,
  payload: {
    error: error,
  }
});

export const getAddressById = (id, data = {}) => {
  return async (dispatch, getState) => {
    dispatch(getAddressByIdRequest(getState().addressBook.addressItems[id], id));

    AddressBookApi.getAddressById(id, { ...data, 'include_relocation_personnel': true }, dispatch)
      .then((response) => {
        dispatch(getAddressByIdSuccess(response.data.data));
      })
      .catch((error) => {
        dispatch(getAddressByIdFailure(error.response))
      });
  };
};




// WEBPACK FOOTER //
// ./src/redux/actions/AddressDetail.js